module.exports = __webpack_public_path__ + "img/notFound@2x.f238c1ff.png";